// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__21wCj","info":"UpdateTermsInfo_info__1_i7F"};